import { AddCircleIcon, IconSize, IconWrapper, Link } from '@dreryk/react-components';

import { useFormsTemplatesContext } from '../formsTemplatesContext';
import { formsTemplatesTranslationKeys } from '../translations';

import { EMPTY_TEMPLATE_ID } from './FormsTemplatesListItemsRenderer';

export const FormsTemplatesAddNewItemLink = (): JSX.Element | null => {
   const { activeItem, addNewItem, items, mode } = useFormsTemplatesContext();

   if (activeItem?.id === EMPTY_TEMPLATE_ID || items.length === 0 || mode !== 'READ_ONLY') {
      return null;
   }

   return (
      <Link
         testId={'addNewTemplate'}
         label={formsTemplatesTranslationKeys.addTemplate}
         onClick={addNewItem}
         icon={
            <IconWrapper testId={'add'} size={IconSize.SMALL}>
               <AddCircleIcon />
            </IconWrapper>
         }
      />
   );
};
